export default __webpack_public_path__ + "static/image3-6d0c8227408731814d0ad283224bd13b.jpg";